import { render, staticRenderFns } from "./educationDivisionEnv.vue?vue&type=template&id=5bd01d4e"
import script from "./educationDivisionEnv.vue?vue&type=script&lang=js"
export * from "./educationDivisionEnv.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd01d4e')) {
      api.createRecord('5bd01d4e', component.options)
    } else {
      api.reload('5bd01d4e', component.options)
    }
    module.hot.accept("./educationDivisionEnv.vue?vue&type=template&id=5bd01d4e", function () {
      api.rerender('5bd01d4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/edu/div/educationDivisionEnv.vue"
export default component.exports